import { render, staticRenderFns } from "./EditAbsencesPage.vue?vue&type=template&id=634f9b03&"
import script from "./EditAbsencesPage.vue?vue&type=script&lang=js&"
export * from "./EditAbsencesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports